var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toggle--wrapper relative flex items-center",class:{ disabled: _vm.disabled },on:{"click":function($event){_vm.$emit('click', $event);
    _vm.$emit('input', !_vm.value);}}},[_c('div',{staticClass:"toggle--indicator mr-15",class:{ checked: _vm.value }}),_c('span',[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }